import type { Product } from "../data/products";

const view = "0 0 160 160";

const paths: Record<Product["motif"], string> = {
  ring: "M80 46a34 34 0 1 1 0 68a34 34 0 1 1 0-68 M80 62a18 18 0 1 1 0 36a18 18 0 1 1 0-36",
  necklace:
    "M40 34c18 38 28 58 40 74c12-16 22-36 40-74 M80 108l8 14h-16z",
  earring:
    "M52 40a16 16 0 1 1 0 32a16 16 0 1 1 0-32 M108 40a16 16 0 1 1 0 32a16 16 0 1 1 0-32 M52 72v20 M108 72v20 M46 92h12 M102 92h12",
  bracelet: "M44 80a36 22 0 1 1 72 0a36 22 0 1 1-72 0 M118 80h10"
};

export function JewelleryMotif({
  motif,
  title
}: {
  motif: Product["motif"];
  title?: string;
}) {
  const decorative = !title;

  return (
    <svg
      viewBox={view}
      role={decorative ? "presentation" : "img"}
      aria-hidden={decorative ? true : undefined}
      aria-label={decorative ? undefined : title}
      width="220"
      height="220"
    >
      <rect x="8" y="8" width="144" height="144" fill="none" stroke="#3a3228" />
      <rect x="16" y="16" width="128" height="128" fill="none" stroke="#d4b483" strokeOpacity="0.45" />
      <path
        d={paths[motif]}
        fill="none"
        stroke="#d4b483"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
